import {useMemo} from 'react';
import {t} from '../../../../common/getTranslations';
import {useDialog} from '../../../../dialog/useDialog.hook';
import {Maybe, SortOption} from '../../../../graphql/generated/types';
import {LOG_CLICK_EVENT} from '../../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';

export function useProductListSortOptDialog({
  isMobile,
  sortOptList,
  selectedSortOpt,
  onSelectSortOption,
  isProductList,
}: {
  isMobile: boolean;
  sortOptList: Maybe<Array<Maybe<SortOption>>>;
  selectedSortOpt: Maybe<SortOption>;
  onSelectSortOption: (sortOpt: SortOption) => void;
  isProductList?: boolean;
}) {
  const {DialogWrapper, Dialog, showDialog, hideDialog} = useDialog({
    isMobile,
  });
  const dialogElem = useMemo(() => {
    return (
      <DialogWrapper isUsingScrollBlock={false}>
        <Dialog.Dimmed />
        <Dialog.List className="space-y-0">
          {sortOptList &&
            sortOptList.map(opt => {
              if (!opt) return;
              return (
                <Dialog.Option
                  key={opt.param}
                  {...putTiaraObjectProps({
                    click: {
                      layer1: isProductList ? '필터정렬' : '전체회차목록',
                      copy: opt.name,
                    },
                    customProps: {
                      page_sort: selectedSortOpt?.name,
                    },
                  })}
                  onClick={e =>
                    LOG_CLICK_EVENT('정렬_클릭', e, () => {
                      onSelectSortOption(opt);
                      hideDialog();
                    })
                  }
                  isChecked={
                    opt.param ===
                    (selectedSortOpt?.param ?? sortOptList[0]?.param)
                  }
                >
                  {opt.name}
                </Dialog.Option>
              );
            })}
        </Dialog.List>
        <Dialog.BottomCombination>
          <Dialog.Button onClick={hideDialog}>
            {t('common_cancel_button')}
          </Dialog.Button>
        </Dialog.BottomCombination>
      </DialogWrapper>
    );
  }, [
    Dialog,
    DialogWrapper,
    hideDialog,
    isProductList,
    onSelectSortOption,
    selectedSortOpt,
    sortOptList,
  ]);

  return {
    showDialog,
    hideDialog,
    productListSortOptDialog: dialogElem,
  };
}
